import { Box, Grid, Button } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import classes from "./../wizard/TaskmapWizard.module.css";
import TaskmapSlider from "./TaskmapSlider";
import TaskmapHistogram from "./TaskmapHistogram";
import { CutoffRange } from "../taskmap.types";

export function DownloadTaskmapStep({
  cutoff,
  setCutoff,
  totalTreeCount,
  sortedData,
  header,
  label,
  onSubmit,
  loading,
}: {
  cutoff: CutoffRange;
  setCutoff: (cutoff: CutoffRange) => void;
  totalTreeCount: number;
  sortedData: number[];
  header: React.ReactNode;
  label: string;
  onSubmit: () => void;
  loading: boolean;
}): React.ReactNode {
  const { t } = useTranslation();

  return (
    <>
      <Grid size={{ xs: 12, md: 6 }}>
        <Box sx={{ display: "flex", alignItems: "baseline", gap: 2 }}>
          <h1>{header}</h1>
        </Box>
        <TaskmapSlider
          cutoff={cutoff}
          setCutoff={setCutoff}
          sortedData={sortedData}
          totalTreeCount={totalTreeCount}
        />
        <Grid container spacing={3} className={` ${classes.buttonGrid}`}>
          <Button
            variant="contained"
            onClick={onSubmit}
            loading={loading}
            fullWidth
          >
            {t("button.generate")}
          </Button>
        </Grid>
      </Grid>
      <Grid size={{ xs: 12, md: 6 }}>
        <TaskmapHistogram
          label={label}
          cutoff={cutoff}
          setCutoff={setCutoff}
          sortedData={sortedData}
        />
      </Grid>
    </>
  );
}
